import React from 'react';
import { AudioWaveform, Cpu, Sliders, Layers } from 'lucide-react';
export function Features() {
  const features = [{
    icon: AudioWaveform,
    name: 'Harmonic Forge™',
    description: 'Our core synthesis engine that generates ultra-realistic audio waveforms from text input in milliseconds.'
  }, {
    icon: Cpu,
    name: 'Spectral Engine',
    description: 'Advanced post-processing that cleans artifacts and enhances frequency response for broadcast quality.'
  }, {
    icon: Sliders,
    name: 'Resonance Lab',
    description: 'Fine-tune pitch, speed, emotion, and breath control to get the exact performance you need.'
  }, {
    icon: Layers,
    name: 'Chromatic Blend',
    description: 'Seamlessly mix multiple voices in a single track for dialogues, podcasts, and dramatic scenes.'
  }];
  return <section id="features" className="py-24 bg-[#0F0F16] border-y border-white/5" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="mb-16" data-id="element-11">
          <span className="text-[#FF00AA] font-mono text-sm tracking-widest uppercase mb-2 block" data-id="element-12">
            Technology
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-13">
            Powered by Innovation
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-14">
          {features.map((feature, index) => <div key={index} className="group p-6 rounded-xl bg-[#0A0A0F] border border-white/5 hover:border-[#FF00AA]/50 transition-all duration-300" data-id="element-15">
              <div className="w-12 h-12 bg-[#FF00AA]/10 rounded-lg flex items-center justify-center text-[#FF00AA] mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-16">
                <feature.icon size={24} data-id="element-17" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-mono" data-id="element-18">
                {feature.name}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-19">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}